import script from "./SignUpAutoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpAutoPage.vue?vue&type=script&setup=true&lang=js"

import "./SignUpAutoPage.vue?vue&type=style&index=0&id=35517407&lang=scss"

const __exports__ = script;

export default __exports__